import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var Permissions =
/*#__PURE__*/
function () {
  function Permissions() {
    _classCallCheck(this, Permissions);
  }

  _createClass(Permissions, null, [{
    key: "GetPermissions",
    value: function GetPermissions() {
      return axios.get("/api/permissions");
    }
  }, {
    key: "CreateUserPermission",
    value: function CreateUserPermission(userPermission) {
      return axios.post("api/permissions/CreateUserPermission", userPermission);
    }
  }, {
    key: "GetUserPermission",
    value: function GetUserPermission(userId) {
      return axios.get("api/permissions/".concat(userId));
    }
  }, {
    key: "GetTabPermissions",
    value: function GetTabPermissions(userId) {
      return axios.get("/api/Permissions/GetTabPermissions/".concat(userId));
    }
  }]);

  return Permissions;
}();

export { Permissions as default };